<template>
  <a :href="url" :target="target" :class="buttonClass">
    <span :class="icon ? 'mr-2' : ''" v-if="text">{{ text }}</span>
    <span v-if="icon"><i :class="icon"></i></span>
  </a>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';

interface ButtonProps {
  url?: string;
  text?: string;
  type?:
    | 'primary'
    | 'secondary'
    | 'primary-negative'
    | 'secondary-negative'
    | 'primary-icon'
    | 'linkButton'
    | 'linkButton-negative'
    | 'secondary-white-hover';
  target?: '_blank' | '_self';
  icon?: string; //class name for fa icon or svg class
}

const props = withDefaults(defineProps<ButtonProps>(), {
  type: 'primary',
  target: '_self',
  url: '#',
  text: '',
  icon: '',
});

const buttonClass = computed(() => {
  const typeMap: Record<string, string> = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    'primary-negative': 'btn-primary-negative',
    'secondary-negative': 'btn-secondary-negative',
    'primary-icon': 'btn-primary-icon',
    linkButton: 'btn-link',
    'linkButton-negative': 'btn-link-negative',
    'secondary-white-hover': 'btn-secondary-white-hover',
  };

  return typeMap[props.type] || 'btn-primary';
});
</script>
